<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="明细记录" width="80%" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit" @cancel="cancel"
        :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24" v-if="!props.detailData">
                            <a-form-item label="业务平台" name="buss_platform_id">
                                <PlatformAllPick v-model:value="queryParam.buss_platform_id" mode="multiple">
                                </PlatformAllPick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24" v-if="!props.detailData">
                            <a-form-item label="代理商">
                                <a-input v-model:value="queryParam.nickname" placeholder="请输入"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="类型" name="type">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.type" placeholder="请选择">
                                    <a-select-option :value="1">充值</a-select-option>
                                    <a-select-option :value="2">消费</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="充值方式" name="payment_method">
                                <a-select allow-clear mode="multiple" v-model:value="queryParam.payment_method"
                                    placeholder="请选择">
                                    <a-select-option :value="1">转对公</a-select-option>
                                    <a-select-option :value="2">线下付款</a-select-option>
                                    <a-select-option :value="6">报销转余额</a-select-option>
                                    <a-select-option :value="7">余额支付退款</a-select-option>
                                    <a-select-option :value="8">微信支付</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="备注">
                                <a-input v-model:value="queryParam.remark" placeholder="备注"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col> <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                    <a-row v-if="state.todayPlatformYsk">
                        <a-divider></a-divider>
                        <a-col :md="3" :sm="24">
                            <a-statistic title="用户充值预收款（微信）" :precision="2" :value="state.todayPlatformYsk.yskcz8" />
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <a-statistic title="用户充值预收款（对公）" :precision="2" :value="state.todayPlatformYsk.yskcz1" />
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <a-statistic title="用户充值预收款（线下）" :precision="2" :value="state.todayPlatformYsk.yskcz2" />
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <a-statistic title="用户充值预收款总计" :precision="2" :value="state.todayPlatformYsk.yskcz" />
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <a-statistic title="用户消费预收款" :precision="2" :value="state.todayPlatformYsk.yskxf" />
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <a-statistic title="用户剩余未消费预收款" :precision="2" :value="state.todayPlatformYsk.yskye" />
                        </a-col>
                        <a-col :md="3" :sm="24">
                            <a-statistic title="用户充值预收款产生手续费" :precision="2" :value="state.todayPlatformYsk.ysksxf" />
                        </a-col>
                        <a-divider></a-divider>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'shouxu_money'">
                        {{ text ?? '-' }}
                    </template>
                    <template v-if="column.dataIndex === 'remark'">
                        {{ text ?? '-' }}
                    </template>
                    <template v-if="column.dataIndex === 'payee'">
                        {{ text ?? '-' }}
                    </template>
                    <template v-else-if="column.dataIndex == 'type'">
                        <a-tag v-if="record.type == 1" color="blue">充值</a-tag>
                        <a-tag v-if="record.type == 2" color="green">消费</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">

                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import PlatformAllPick from '@/components/base/PlatformAllPick.vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '代理商',
        dataIndex: 'nickname',
    },
    {
        title: '平台',
        dataIndex: 'platform_name',

    },
    {
        title: '类型',
        dataIndex: 'type',
    },
    {
        title: '改变前',
        dataIndex: 'before_money',
    },
    {
        title: '改变金额',
        dataIndex: 'money',
    },

    {
        title: '改变后',
        dataIndex: 'after_money',
    },
    {
        title: '充值方式',
        dataIndex: 'pay_method_name',
    },
    {
        title: '手续费',
        dataIndex: 'shouxu_money',
    },
    {
        title: '时间',
        dataIndex: 'created_at',
    },
    {
        title: '备注',
        dataIndex: 'remark',
    },
    {
        title: '收款人',
        dataIndex: 'payee',
    },
    {
        title: '操作',
        dataIndex: 'operate'
    }
]
interface state {
    loading: boolean
    detailData: object
    todayPlatformYsk: any
}
const state = reactive<state>({
    loading: false,
    detailData: {},
    todayPlatformYsk: null
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    queryParam.pid = props.detailData && props.detailData.id ? props.detailData.id : 0
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformBalance/recordList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))

        //显示总的金额
        if (res.data.statistics) {
            state.todayPlatformYsk = res.data.statistics.todayPlatformYsk
        } else {
            state.todayPlatformYsk = null
        }
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
